module.exports = __webpack_public_path__ + "static/img/def_cover.21cef12.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/def_cover.png?v=3
// module id = i0/f
// module chunks = 1